export const AUTH_PAGE_LAYOUT_CLASS =
  "gap-10 overflow-y-auto px-9 pt-[calc(var(--safe-area-inset-top,env(safe-area-inset-top,0px))+2rem)]";

export const AUTH_FORM_LAYOUT_CLASS = "flex min-h-0 w-full flex-1 flex-col";

export const AUTH_ACTIONS_LAYOUT_CLASS =
  "mt-[clamp(2rem,5dvh,4rem)] flex flex-col gap-5 pb-[calc(var(--safe-area-inset-bottom,env(safe-area-inset-bottom,0px))+3rem)]";
